export const PERMISSION_KEY = {
  DATA_MANAGEMENT: 'DATA_MANAGEMENT',
  DATA_MANAGEMENT_FOR_SALE: 'DATA_MANAGEMENT_FOR_SALE',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  PRODUCT_AND_WAREHOUSE: 'PRODUCT_AND_WAREHOUSE',
  ACCOUNTING: 'ACCOUNTING',
  ACCOUNTING_DETAIL: 'ACCOUNTING_DETAIL',
  SYSTEM_CONFIGURATION: 'SYSTEM_CONFIGURATION',
  REPORT: 'REPORT',
  COMPANY_MANAGEMENT: 'COMPANY_MANAGEMENT',
  ADMIN_MANAGEMENT: 'ADMIN_MANAGEMENT',
  CALL_CENTER_MANAGEMENT: 'CALL_CENTER_MANAGEMENT',
  CALL_CENTER_LIST_MANAGEMENT: 'CALL_CENTER_LIST_MANAGEMENT',
  CALL_CENTER_ABOUT: 'CALL_CENTER_ABOUT',
  PARAM_CONFIG: 'PARAM_CONFIG',
  MARKETING: 'MARKETING',
  USER_CALL_CENTER_MANAGEMENT: 'USER_CALL_CENTER_MANAGEMENT',
  SYNC_SOCIAL_NETWORK: 'SYNC_SOCIAL_NETWORK',
  PHONE_NUMBER_MANAGER: 'PHONE_NUMBER_MANAGER',
  PHONE_NUMBER_TECHNICAL: 'PHONE_NUMBER_TECHNICAL',
  PHONE_NUMBER_ADMIN: 'PHONE_NUMBER_ADMIN'
}

export const ROUTING = {
  DATA_MANAGEMENT: 'OrderList',
  USER_MANAGEMENT: 'UserList',
  PRODUCT_AND_WAREHOUSE: 'ProductList',
  ACCOUNTING: 'AccountingList',
  REPORT: 'ReportNewOrder',
  COMPANY_MANAGEMENT: 'CompanyList',
  ADMIN_MANAGEMENT: 'AdminList',
  CALL_CENTER_MANAGEMENT: 'ExtUserManagement',
  CALL_CENTER_LIST_MANAGEMENT: 'CallCenterListManagement',
  CALL_CENTER_ABOUT: 'CallCenterIntro',
  PARAM_CONFIG: 'ParamList',
  MARKETING: 'FacebookConnect',
  PACKAGE_MANAGEMENT: 'Package',
  PHONE_NUMBER_MANAGER: 'CallCenterIntro',
  PHONE_NUMBER_TECHNICAL: 'CallCenterIntro',
  PHONE_NUMBER_ADMIN: 'CallCenterIntro'
}

export const PERMISSION_VALUE = {
  MARKETING: 'Marketing',
  DATA_MANAGEMENT: 'Quản lý data',
  DATA_MANAGEMENT_FOR_SALE: 'Quản lý data cho nhân viên sale',
  USER_MANAGEMENT: 'Quản lý nhân sự',
  PRODUCT_AND_WAREHOUSE: 'Sản phẩm và kho hàng',
  ACCOUNTING: 'Tài chính - Kế toán',
  ACCOUNTING_TOTAL: 'Hóa đơn chưa phân bổ',
  ACCOUNTING_DETAIL: 'Hóa đơn chi tiết',
  SYSTEM_CONFIGURATION: 'Tuỳ chỉnh hệ thống',
  REPORT: 'Báo cáo',
  COMPANY_MANAGEMENT: 'Quản lý doanh nghiệp',
  ADMIN_MANAGEMENT: 'Quản lý tài khoản admin',
  CALL_CENTER_MANAGEMENT: 'Quản lý tổng đài admin',
  CALL_CENTER_LIST_MANAGEMENT: 'Quản lý tổng đài',
  CALL_CENTER_ABOUT: 'Giới thiệu tổng đài',
  PARAM_CONFIG: 'Thiết lập cấu hình',
  USER_CALL_CENTER_MANAGEMENT: 'Quản lý tổng đài',
  PHONE_NUMBER_MANAGER: 'Quản lý số',
  PHONE_NUMBER_TECHNICAL: 'Quản lý sự cố số',
  PHONE_NUMBER_ADMIN: 'Quản lý số'
}

export const SUPER_ADMIN_MENU = [PERMISSION_KEY.COMPANY_MANAGEMENT, PERMISSION_KEY.ADMIN_MANAGEMENT, PERMISSION_KEY.PARAM_CONFIG]
export const ADMIN_MENU = [PERMISSION_KEY.USER_MANAGEMENT, PERMISSION_KEY.PRODUCT_AND_WAREHOUSE, PERMISSION_KEY.CALL_CENTER_MANAGEMENT]
export const ADMIN_MENU_WITHOUT_CALL_CENTER = [PERMISSION_KEY.USER_MANAGEMENT, PERMISSION_KEY.PRODUCT_AND_WAREHOUSE, PERMISSION_KEY.CALL_CENTER_ABOUT]

export const Constant = {
  TOKEN_NAME: 'Token',
  REFRESH_TOKEN: 'Refresh',
  EDIT_PERMISSIONS: 'EditPermission',
  READ_PERMISSIONS: 'ReadPermission',
  MENU_PERMISSIONS: 'MenuPermission',
  APP_USR: 'UserInfo',
  PERMISSION_LIST: [
    {name: PERMISSION_VALUE.MARKETING, code: PERMISSION_KEY.MARKETING},
    {name: PERMISSION_VALUE.DATA_MANAGEMENT, code: PERMISSION_KEY.DATA_MANAGEMENT},
    {name: PERMISSION_VALUE.DATA_MANAGEMENT_FOR_SALE, code: PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE},
    {name: PERMISSION_VALUE.USER_MANAGEMENT, code: PERMISSION_KEY.USER_MANAGEMENT},
    {name: PERMISSION_VALUE.PRODUCT_AND_WAREHOUSE, code: PERMISSION_KEY.PRODUCT_AND_WAREHOUSE},
    {name: PERMISSION_VALUE.ACCOUNTING, code: PERMISSION_KEY.ACCOUNTING},
    {name: PERMISSION_VALUE.SYSTEM_CONFIGURATION, code: PERMISSION_KEY.SYSTEM_CONFIGURATION},
    {name: PERMISSION_VALUE.REPORT, code: PERMISSION_KEY.REPORT},
    {name: PERMISSION_VALUE.USER_CALL_CENTER_MANAGEMENT, code: PERMISSION_KEY.USER_CALL_CENTER_MANAGEMENT},
    {name: PERMISSION_VALUE.PHONE_NUMBER_MANAGER, code: PERMISSION_KEY.PHONE_NUMBER_MANAGER},
    {name: PERMISSION_VALUE.PHONE_NUMBER_TECHNICAL, code: PERMISSION_KEY.PHONE_NUMBER_TECHNICAL}
  ]
}

export const MENU_TYPE = {
  ALL: 'all',
  NORMAL: 'normal',
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
}

export const ERROR_CODE = {
  '1001': 'Không tìm thấy tài khoản hoặc vui lòng kiểm tra lại tài khoản/mật khẩu',
  '1002': 'Tài khoản chưa đăng nhập',
  '2000': 'Tham số đã tồn tại',
  '2001': 'Không tìm thấy tham số',
  '2010': 'Tham số đã tồn tại',
  '2011': 'Không tìm thấy gói cước',
  '2020': 'Doanh nghiệp đã tồn tại',
  '2021': 'Không tìm thấy doanh nghiệp',
  '2030': 'Phòng ban đã tồn tại',
  '2031': 'Không tìm thấy phòng ban',
  '2032': 'Không xóa được phòng/ban do vẫn còn người dùng active',
  '2040': 'Chức vụ đã tồn tại',
  '2041': 'Không tìm thấy chức vụ',
  '2050': 'Quyền đã tồn tại',
  '2051': 'Không tìm thấy chức vụ',
  '2060': 'Tài khoản đã tồn tại',
  '2061': 'Không tìm thấy tài khoản',
  '3001': 'Không tìm thấy sản phẩm',
  '3002': 'Sản phẩm đã tồn tại',
  '3003': 'Cấu hình tổng đài không tồn tại',
  '3004': 'Tài khoản SIP không đúng',
  '3006': 'Không tìm thấy Agent',
  '3007': 'Chưa đăng ký Agent',
  '3008': 'Bị trùng tham số',
  '3010': 'Tổng đài chưa chốt sổ',
  '3011': 'Không tìm thấy log',
  '3012': 'Báo cáo không tồn tại',
  '3013': 'Số lượng agent không khớp với số lượng trong tệp tin',
  '5007': 'Thanh toán cho đơn hàng không có sản phẩm',
  '5008': 'Số tiền thanh toán vượt quá giá trị hợp đồng',
  '5009': 'Không thể xóa/sửa đơn hàng khi kế toán đã phê duyệt thanh toán',
  '8001': 'Công ty đã vượt quá số tiền ứng trước cho chức năng tổng đài',
  '9011': 'Số điện thoại đang tồn tại',
  '9012': 'Không tìm thấy số điện thoại',
  '9017': 'Ngày mở hoặc ngày khóa không được nhỏ hơn ngày lấy số',
  '10001': 'Cập nhập trạng thái số khóa không đúng',
  '1': 'Từ chối truy cập',
  '2': 'Không thể kết nối tới máy chủ',
}

export const IMPORT_ERROR_CODE = {
  '1': 'Sai định dạng số điện thoại',
  '2': 'Trạng thái chính trống nhưng trạng thái phụ có giá trị',
  '3': 'Không tìm thấy trạng thái chính',
  '4': 'Không tìm thấy trạng thái phụ',
  '5': 'Id đang trống, bắt buộc có id',
  '6': 'Id không phải là số',
  '7': 'Nguồn data trống nhưng kênh nguồn data có giá trị',
  '8': 'Không tìm thấy nguồn data',
  '9': 'Không tìm thấy kênh nguồn data',
  '10': 'Sai định dạng email',
  '11': 'Mã đơn hàng bị trống',
  '12': 'Mã đơn hàng sai định dạng',
  '13': 'Không tìm thấy đơn hàng',
  '14': 'Giá trị thanh toán nhập vào đang không phải là số',
  '15': 'Import dữ liệu thanh toán cho đơn hàng không có sản phẩm mua 1 lần',
  '16': 'Số điện thoại bị trùng',
  '17': 'Không tìm thấy số chủ',
  '18': 'Không tìm thấy nhà cung cấp',
  '19': 'Không tìm thấy pháp nhân',
  '20': 'Không tìm thấy SĐT Khách hàng',
  '21': 'Không tìm thấy trạng thái số',
  '22': 'Ngày lấy sai định dạng',
  '23': 'Ngày hủy sai định dạng',
  '24': 'Ngày nhập phí mở sai định dạng',
  '25': 'Ngày nhập phí khởi tạo sai định dạng',
  '26': 'Ngày nhập phí duy trì sai định dạng',
  '27': 'Ngày nhập phí khác sai định dạng',
  '28': 'Phí khởi tạo rỗng',
  '29': 'Phí khởi tạo không phải định dạng số',
  '30': 'Phí khởi tạo không được = 0',
  '31': 'Phí duy trì rỗng',
  '32': 'Phí duy trì không phải định dạng số',
  '33': 'Phí duy trì không được = 0',
  '34': 'Không tìm thấy số điện thoại',
  '35': 'Phí nội mạng không được để trống',
  '36': 'Sai định dạng phí nội mạng',
  '37': 'Phí nội mạng phải lớn hơn 0',
  '38': 'Phí ngoại mạng không được để trống',
  '39': 'Sai định dạng phí ngoại mạng',
  '40': 'Phí ngoài mạng phải lớn hơn 0',
  '41': 'Ngày nhập phí sai định dạng YYYY-MM-DD',
  '42': 'Tháng tính phí sai định dạng YYYY-MM',
  '43': 'Số mới nhập chỉ được chuyển thành số đạt hoặc số không đạt',
  '44': 'Số Đang nghi ngờ chỉ được chuyển thành Đang bị khoá hoặc Cảnh báo sai',
  '45': 'Số Test sau mở được chuyển thành Đang bị khoá hoặc Số đã mở',
  '46': 'Số Chờ hủy chỉ được chuyển thành xác nhận hủy',
  '47': 'Số Không được sử dụng chỉ được chuyển thành Xác nhận không sử dụng',
  '49': 'Ngày khóa Viettel sai định dạng',
  '50': 'Ngày khóa Mobi sai định dạng',
  '51': 'Ngày khóa Vina sai định dạng',
  '52': 'Ngày khóa Ngoại mạng sai định dạng',
  '53': 'Ngày mở Viettel sai định dạng',
  '54': 'Ngày mở Mobi sai định dạng',
  '55': 'Ngày mở Vina sai định dạng',
  '56': 'Ngày mở Ngoại mạng sai định dạng',
  '57': 'Ngày khách lấy sai định dạng'
}

export const CALL_STATE = {
  RECEIVED: 'Received',
  ANSWERED: 'Answered',
  CREATED: 'Created',
  HANGUP: 'Hangup'
}

export const CALL_OUT_RESULT = {
  BUSY: 'Busy'
}

export const CALL_TYPE = {
  CALL_IN: 'CallIn',
  CALL_OUT: 'CallOut',
  CALL_IN_CREATE: 'CallOut',
  CALL_OUT_CREATE: 'CallOut',
}

export const PAYMENT_METHOD_KEY = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT'
}

export const PAYMENT_METHOD = {
  'DEBIT': 'Thanh toán 1 lần',
  'CREDIT': 'Thanh toán hàng tháng'
}

export const PRODUCT_DELETE_TYPE = {
  'ACTIVE': 'Chưa xóa',
  'ALL': 'Tất cả',
  'DELETED': 'Đã xóa',
}

export const CALL_CENTER_CONFIG = {

  PRODUCT_TYPES: [
    {
      name: 'Gói',
      code: 'AGENT'
    },
    {
      name: 'Sip/phút',
      code: 'MINUTE'
    }],
  PAYMENT_TYPES: [
    {
      name: 'Trả trước',
      code: 'DEBIT'
    },
    {
      name: 'Trả sau',
      code: 'CREDIT'
    }],
  SIP_METHOD: [
    {
      name: '6+1',
      code: '6+1'
    },
    {
      name: '60+1',
      code: '60+1'
    }
  ],
  DISCOUNT_TYPES: [
    {
      name: 'Giá',
      code: 'VALUE'
    },
    {
      name: 'Phần trăm',
      code: 'PERCENT'
    }
  ],
}

export const DEBT_STATUS_LIST = [
  {text: 'Đã nhắc thanh toán', value: 'NOTIFIED'},
  {text: 'Chưa thanh toán', value: 'UNPAID'},
  {text: 'KT Chưa duyệt', value: 'UNAPPROVED'},
  {text: 'KT Đã duyệt', value: 'APPROVED'}
]

export const CALL_STATUS_LIST = [
  {text: 'Nghe máy', value: 'ANSWERED'},
  {text: 'Không nghe máy', value: 'NO ANSWER'},
  {text: 'Máy bận', value: 'BUSY'}
]

export const PHONE_STATUS = [
  {text: 'SỐ MỚI NHẬP', value: 'NEW_NUMBER'},
  {text: 'SỐ ĐẠT', value: 'SATISFIED_NUMBER'},
  {text: 'ACTIVE', value: 'ACTIVE'},
  {text: 'NGHI NGỜ', value: 'SUSPECT'},
  {text: 'KHOÁ', value: 'LOCKED'},
  {text: 'CHỜ MỞ', value: 'WAIT_UNLOCK'},
  {text: 'ĐÃ MỞ', value: 'UNLOCKED'},
  {text: 'HUỶ', value: 'CANCEL'}
]

export const NUMBER_OF_LOCKED_LIST = [
  {text: '0', value: '0'},
  {text: '1', value: '1'},
  {text: '2', value: '2'},
  {text: '3', value: '3'},
  {text: '4', value: '4'},
  {text: '5', value: '5'},
  {text: '>=5', value: '6'}
]

export const LOCK_COUNT_TYPE = [
  {text: 'Viettel', value: 'Viettel'},
  {text: 'Mobifone', value: 'Mobifone'},
  {text: 'Vinaphone', value: 'Vinaphone'},
  {text: 'Ngoại mạng', value: 'Other'}
]

export const FEE_TYPE_LIST = [
  {text: 'Phí tạo', value: 'CREATION_FEE'},
  {text: 'Phí duy trì', value: 'MAINTAINING_FEE'},
  {text: 'Phí mở', value: 'OPENING_FEE'},
  {text: 'Phí hàng tháng', value: 'MONTHLY_FEE'},
  {text: 'Phí khác', value: 'OTHER_FEES'}
]

export const LOCAL_STORAGE_KEY = {
  ORDER_LIST_SEARCH_ITEMS: 'ORDER_LIST_SEARCH_ITEMS',
  PHONE_NUMBER_SEARCH_ITEMS: 'PHONE_NUMBER_SEARCH_ITEMS',
  PHONE_NUMBER_COLUMN_SHOW: 'PHONE_NUMBER_COLUMN_SHOW',
  CHECKED_PHONE_NUMBER_COLUMN_SHOW: 'CHECKED_PHONE_NUMBER_COLUMN_SHOW',
  PHONE_NUMBER_SEARCH_ITEM_TECH: 'PHONE_NUMBER_SEARCH_ITEM_TECH',
  PHONE_NUMBER_COLUMN_SHOW_TECH: 'PHONE_NUMBER_COLUMN_SHOW_TECH',
  ORDER_LIST_FROM_DATE: 'ORDER_FROM_DATE',
  ORDER_LIST_TO_DATE: 'ORDER_TO_DATE',
  REPORT_NEW_ORDER_SEARCH_ITEMS: 'REPORT_NEW_ORDER_SEARCH_ITEMS',
  REPORT_ANNUAL_REVENUE_SEARCH_ITEMS: 'REPORT_ANNUAL_REVENUE_SEARCH_ITEMS',
  REPORT_BAD_DEBT_SEARCH_ITEMS: 'REPORT_BAD_DEBT_SEARCH_ITEMS',
  ACCOUNTING_SEARCH_ITEMS: 'ACCOUNTING_SEARCH_ITEMS',
  LEGAL_LIST: 'LEGAL_LIST',
  MAIN_PHONE_NUMBER_LIST: 'MAIN_PHONE_NUMBER_LIST',
  PHONE_NUMBER_CLIENT: 'PHONE_NUMBER_CLIENT',
  PHONE_STATUS_LIST: 'PHONE_STATUS_LIST',
  PROVIDER_LIST: 'PROVIDER_LIST',
  CHECKED_PHONE_NUMBER_CREATED_AT: 'CHECKED_PHONE_NUMBER_CREATED_AT',
}

export const NOTIFICATION_TYPE = {
  DEBT: 'DEBT',
  RENEW: 'RENEW',
  ANNUAL_BUY: 'ANNUAL_BUY',
  APPROVE_PAYMENT: 'APPROVE_PAYMENT',
  UNAPPROVE_PAYMENT: 'UNAPPROVE_PAYMENT',
  NEW_PAYMENT: 'NEW_PAYMENT'
}

export const PAYMENT_STATUS_LIST = [
  {text: 'Chờ xác nhận', value: 'WAITING_APPROVAL'},
  {text: 'Đã duyệt', value: 'APPROVED'},
  {text: 'Không duyệt', value: 'DISAPPROVED'},
  {text: 'Đã xóa', value: 'DELETED'},
  {text: 'Hủy bởi kế toánt', value: 'CANCELLED'}
]

export const MAX_PRODUCT_NUMBER = 500
export const MAX_SALE_USER_NUMBER = 500

export const PROVIDER_NAME = [
  'viettel',
  'vinaphone',
  'mobifone',
  'other'
]

export const PROVIDERS = [
  {text: 'Viettel', value: 'Viettel'},
  {text: 'Mobifone', value: 'Mobifone'},
  {text: 'Vinaphone', value: 'Vinaphone'},
  {text: 'Ngoại mạng', value: 'Other'}
]

export const STATUS_PHONE_NUMBER = {
  LOCKED: 'Đang bị khoá',
  MONITORING: 'Đang nghi ngờ',
  FALSE_POSITIVE: 'Cảnh báo sai',
  NEW: 'Số mới nhập',
  QUALIFIED: 'Số đạt',
  UNQUALIFIED: 'Số không đạt',
  RETEST: 'Test sau mở',
  UNLOCKED: 'Số đã mở',
  WAIT_CANCEL: 'Chờ hủy',
  NOT_USE: 'Không được sử dụng',
  CONFIRM_CANCEL: 'Xác nhận hủy',
  CONFIRM_NOT_USE: 'Xác nhận không sử dụng',
  USING: 'Đang sử dụng',
  AVAILABLE: 'Chưa sử dụng'
}



// WEBPACK FOOTER //
// ./src/common/constant.js